import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export const SupportStepsSection: React.FC<{
  paddingTop: number;
}> = ({ paddingTop }) => {
  const { t, ready, i18n } = useTranslation();
  
  // Debug: Log translation status
  console.log('SupportSteps - i18n ready:', ready, 'language:', i18n.language);
  console.log('SupportSteps - support title:', t('landing:support.title'));
  console.log('SupportSteps - support steps:', t('landing:support.steps', { returnObjects: true }));
  
  // Fallback data if translation is not ready - memoized to prevent re-creation
  const fallbackSteps = useMemo(() => [
    { id: 1, title: "Setup Progetto", points: ["Studio requisiti", "Supporto bandi"] },
    { id: 2, title: "Studio Fattibilità", points: ["Studio soluzioni", "Sviluppo prototipi"] },
    { id: 3, title: "Design e Sviluppo", points: ["Programmazione", "Addestramento"] },
    { id: 4, title: "Monitoraggio", points: ["Analisi performance", "Aggiornamento"] }
  ], []);
  
  const fallbackTraining = useMemo(() => ["Fondamenti di IA", "Integrazione dell'IA nei processi"], []);
  
  const steps = useMemo(() => {
    console.log('SupportSteps - steps useMemo triggered, ready:', ready, 'language:', i18n.language);
    // Always try to get translations for current language, fallback to Italian only if translation is missing
    const translatedSteps = t('landing:support.steps', { returnObjects: true }) as Array<{id: number; title: string; points: string[]}>;
    console.log('SupportSteps - translatedSteps:', translatedSteps);
    
    if (Array.isArray(translatedSteps) && translatedSteps.length > 0) {
      return translatedSteps;
    }
    
    // Fallback to Italian if translation is missing
    return fallbackSteps;
  }, [t, i18n.language, fallbackSteps]);
  
  const training = useMemo(() => {
    console.log('SupportSteps - training useMemo triggered, ready:', ready, 'language:', i18n.language);
    // Always try to get translations for current language, fallback to Italian only if translation is missing
    const translatedTraining = t('landing:support.training.items', { returnObjects: true }) as string[];
    console.log('SupportSteps - translatedTraining:', translatedTraining);
    
    if (Array.isArray(translatedTraining) && translatedTraining.length > 0) {
      return translatedTraining;
    }
    
    // Fallback to Italian if translation is missing
    return fallbackTraining;
  }, [t, i18n.language, fallbackTraining]);

  return (
    <div
      id="support"
      className="support-steps__section text-center text-white py-5 section-container"
      key={`support-${i18n.language}`} // Force re-render on language change
    >
      <div className="support-content">
        <h2 className="fw-bold" style={{ paddingTop }}>
          {t('landing:support.title') || 'Ti supportiamo in ogni fase'}
        </h2>
        <div className="row mt-5">
        {steps.map((step) => (
          <div key={step.id} className="col-md-3 mb-md-0 mb-4">
            <div className="p-4 step h-100">
              <h3 className="fw-bold step-id">{step.id}</h3>
              <h5 className="fw-semibold step-title mt-2">{step.title}</h5>
              <div className="step-points">
                {step.points.map((point, index) => (
                  <div key={index} className="step-point-tag">
                    {point}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-md-5 mt-0 step formation-setp">
        <div className="formation-setp-content">
          <h3 className="fw-bold">{t('landing:support.training.title') || 'Formazione'}</h3>
          <div className="training-tags">
            {training.map((item, index) => (
              <div key={index} className="training-tag">
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};


